import { Component } from '@angular/core';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';

@Component({
	selector: 'app-button-showcase',
	templateUrl: './button-showcase.component.html'
})
export class ButtonShowcaseComponent {
	singleButtonElementPrimaryNoIcon: SplitButtonElement = {
		title: 'ui.showcase.primary',
		type: 'primary'
	};
	singleButtonElementPrimaryIcon: SplitButtonElement = {
		title: 'ui.showcase.primary',
		type: 'primary',
		icon: 'edit',
	};
	singleButtonElementPrimaryIconOnly: SplitButtonElement = {
		title: 'ui.showcase.primary',
		type: 'primary',
		icon: 'edit',
		iconOnly: true,
	};
	singleButtonElementSecondaryNoIcon: SplitButtonElement = {
		title: 'ui.showcase.secondary',
		type: 'default'
	};
	singleButtonElementSecondaryIcon: SplitButtonElement = {
		title: 'ui.showcase.secondary',
		type: 'default',
		icon: 'edit',
	};
	singleButtonElementSecondaryIconOnly: SplitButtonElement = {
		title: 'ui.showcase.secondary',
		type: 'default',
		icon: 'edit',
		iconOnly: true,
	};
	singleButtonElementDangerNoIcon: SplitButtonElement = {
		title: 'ui.showcase.delete',
		type: 'danger'
	};
	singleButtonElementPrimaryCallback: SplitButtonElement = {
		title: 'ui.showcase.primary',
		type: 'primary',
		icon: 'edit',
		callback: () => this.testCallBack('Primary'),
	};
	singleButtonElementSecondaryCallback: SplitButtonElement = {
		title: 'ui.showcase.secondary',
		type: 'default',
		icon: 'edit',
		hasDivider: true,
		callback: () => this.testCallBack('Secondary'),
	};

	public testCallBack(buttonType: string): void {
		console.log(buttonType + ' Button click!');
	}
}
